import { Formik, Form, Field, FieldArray,ErrorMessage } from 'formik';
import React, { useState, useEffect } from 'react';
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router';
import moment, { months } from 'moment';
import { useHistory } from "react-router-dom";
import { date } from 'yup/lib/locale';
import Select from 'react-select'
import * as AiIcons from 'react-icons/ai';
import * as Yup from 'yup'
import swal from '@sweetalert/with-react';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import axios from 'axios';



function Stage2AuditPlan() {

    const history = useHistory();
const [ProcessList,setProcessList] = useState(["select"])

    const [leadauditorList, setLeadauditorList] = useState([{
        label: "",
        value: ""
}])
const [assitAuditorList, setassitAuditorList] = useState([{
        label: "",
        value: ""
}])
const [technicalExpertList,setTechnicalExpertList] = useState([{
        label:"",
        value:""
}])
    const [initialValues, setInitialValues] = useState({
        _id: "",
        orgCode: 0,
        auditrepresentative: "",
        scope: "",
        dateofaudit: "",
        personsauditteam: "",
        typeofaudit: "Certification Audit (Stage 2)",
        purpose: "",
        businesssector: "",
        teamleaderName: "",
        accompanyingteam: "",
        purspose: "",
        auditobjective: "To Evaluate The Implementation, Including Effectiveness, Of The Client’s Management System As Per ISO 9001:2015 Requirements",
        standardapplied: "ISO 9001:2015",
        standardapplicable: "All are applicable Requirements",
        technicalexpert: "",
        purposecategories: "DL 33.3(19)",
        translator: "NA",
        languageofaudit: "English, Marathi, Hindi",
        referencedocuments: "Quality manual, Operating Procedures and Work Instructions and ISO Standards",
        processDetails: [{
            dateofaudit:  new Date(),
            processToBeAudited: "",
            processNametobeAudited: "",
            checkBoxSelection: "",
            processGroup: "",
            minutesAssigned: "",
            auditee: "",
            auditorCompulsion: "",
            proposedValue: "",
            proposedValueTo:""

        }],
        auditstarttime: "",
        auditendtime: "",
        fromtime: "",
        lunchendtime: "",
        teamleader: "",      
        auditorOne: "",
        auditorOneName: "",
        auditorTwo: "",
        auditorTwoName: "",
        
    })

    const onSubmit = (values, { setSubmitting, resetForm }) => {

        mutation.mutate(values)

    }

    const validationSchema = Yup.object({
       
        // standardapplicable: Yup.string().required('Required').matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),
       
        // auditstarttime: Yup.string().required('Required'),
        // auditendtime: Yup.string().required('Required'),
        // fromtime: Yup.string().required('Required'),
        auditstarttime : Yup.string().test(
            'not empty',
            'Audit Start time can not be empty',
            function(value) {
              return !!value;
            }
          ),
         
          auditendtime : Yup.string().test(
            'not empty',
            'Audit End time can not be empty',
            function(value) {
              return !!value;
            }
          ),
        fromtime :Yup.string().test(
            'not empty',
            'Lunch start time can not be empty',
            function(value) {
              return !!value;
            }
          ),
          lunchendtime :Yup.string().test(
            'not empty',
            'Lunch End time can not be empty',
            function(value) {
              return !!value;
            }
          ),

        processDetails: Yup.array().of( Yup.object().shape({
            processToBeAudited: Yup.string().required("Process to be Audited Required"),
            checkBoxSelection: Yup.string().required("Process Selection Required"),
            minutesAssigned:Yup.string().required("Minutes Assigned Required"),
            auditorCompulsion:Yup.string().required("Audit Compulsion Required"),
            proposedValue:Yup.string().required("Proposed Value Required"),
           
            })
          )

    })
    const { orgcode } = useParams()
    

    const getUrl = () =>{
        const api= APIURL + '/api/stagetwo/get/stagetwodata/' + orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(stagetwoplandata=>{
            if (stagetwoplandata && initialValues.orgCode === 0 ) {
                var tempData = stagetwoplandata.data.response
                tempData.dateofaudit = Date.parse(tempData.dateofaudit);
                var i=0;
                for(i = 0; i < tempData.processDetails.length; i++ )
                {
                   // tempData.processDetails[i].dateofaudit = (typeof tempData.processDetails[i].dateofaudit === 'string' ? parseInt(tempData.processDetails[i].dateofaudit): Date.parse( tempData.processDetails[i].dateofaudit) )
                   tempData.processDetails[i].dateofaudit = Date.parse( tempData.processDetails[i].dateofaudit )
    
                }
                if(i >= tempData.processDetails.length)
                {
                    
                    tempData.technicalexpert = stagetwoplandata.data.response.technicalexpert
                    setInitialValues(tempData)
                }
                if(tempData.processDetails.length===0)
                {
                    tempData.processDetails= [{
                            dateofaudit: Date.parse(tempData.dateofaudit),
                            processToBeAudited: "",
                            processNametobeAudited: "",
                            checkBoxSelection: "",
                            processGroup: "",
                            minutesAssigned: "",
                            auditee: "", 
                            auditorCompulsion: "",
                            proposedValue: "",
                            proposedValueTo:"",
            
                        }];
                }
               
                if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                    mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
                }
                if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                    mutationAssisAuditorDetails.mutate(tempData.nabcbcode)
                }
                if (tempData.nacecode && tempData.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempData.nacecode)
                }
    
            }

       

            
           
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                window.location.href = "/signin"
            }

        })
       
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])

    const mutation = useMutation((params) => Fetcher('patch', '/api/stagetwo/patch/stagetwoauditdetails', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', ' Stage Two Audit Plan Data Updated')
                window.location.href = "/"+localStorage.getItem("role")+"/view/stage2auditplan/" + data.data.response.orgCode
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationAssisAuditorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforAssistAuditorCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("List of ast Auditor", data.data.response)
                setassitAuditorList(data.data.response)
                
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationLeadAudiorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("Laead Auditor List", data)
            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setLeadauditorList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationTechnicalExpertDetails = useMutation((params) => Fetcher('get', '/api/technicalexpert/get/labelvalueTechnicalExpertCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("data expert",data)
            
            if (data.data.errorCode === 0) {
                console.log("List of Technical Expert",data.data.response)
                setTechnicalExpertList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + params, {}), {

        onSuccess(data) {
        
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                console.log("tempInitialValues",tempInitialValues)
               
                if(tempInitialValues.typeOfCertification === "ISO 27001-2013 ISMS Requirements"){
                    mutationgetProcessList.mutate("27001")
                }else{
                    mutationgetProcessList.mutate("Other")
                }
                if(tempInitialValues.processDetails.length===0)
                {
                    tempInitialValues.processDetails= [{
                            dateofaudit: Date.parse(tempInitialValues.dateofaudit),
                            processToBeAudited: "",
                            processNametobeAudited: "",
                            checkBoxSelection: "",
                            processGroup: "",
                            minutesAssigned: "",
                            auditee: "", 
                            auditorCompulsion: "",
                            proposedValue: "",
                            proposedValueTo:"",
            
                        }];
                }
                else{ 
                    
                    var i=0;
                    for(i = 0; i < tempInitialValues.processDetails.length; i++ )
                    {
                       // tempInitialValues.processDetails[i].dateofaudit = (typeof tempInitialValues.processDetails[i].dateofaudit==='string'? parseInt(tempInitialValues.processDetails[i].dateofaudit): Date.parse( tempInitialValues.processDetails[i].dateofaudit ))
                       tempInitialValues.processDetails[i].dateofaudit = Date.parse( tempInitialValues.processDetails[i].dateofaudit )

                    }
                    if(i >= tempInitialValues.processDetails.length)
                    {
                        
                        tempInitialValues.technicalexpert = data.data.response.technicalexpert
                       
                    }

                }
              
                tempInitialValues.typeofaudit = data.data.response.typeofaudit || "Certification Audit (Stage 2)";
                tempInitialValues.auditrepresentative = data.data.response.auditrepresentative || "";
                // tempInitialValues.dateofaudit = moment(data.data.response.dateofaudit).format("DD-MM-YYYY") || null;
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.scope = data.data.response.scope || "";
                tempInitialValues.proposedscope = data.data.response.proposedscope || "";
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || "";
                tempInitialValues.technicalexpert = data.data.response.technicalexpert || "";
                tempInitialValues.purpose = data.data.response.purpose || "";
                tempInitialValues.accompanyingteam = data.data.response.accompanyingteam || "";
                tempInitialValues.standardapplied = data.data.response.standardapplied || "ISO 9001:2015";
                tempInitialValues.translator = data.data.response.translator || "NA";
                tempInitialValues.purposecategories = data.data.response.purposecategories || "DL 33.3(19)";
                tempInitialValues.languageofaudit = data.data.response.languageofaudit || "English, Marathi, Hindi";
                tempInitialValues.referencedocuments = data.data.response.referencedocuments || "Quality manual, Operating Procedures and Work Instructions and ISO Standards";
                tempInitialValues.standardapplicable = data.data.response.standardapplicable || "All are applicable Requirements";
                tempInitialValues.auditobjective = data.data.response.auditobjective || "To Evaluate The Implementation, Including Effectiveness, Of The Client’s Management System As Per ISO 9001:2015 Requirements"
                tempInitialValues.dateofauditto = Date.parse(data.data.response.dateofauditto) || null;

                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationLeadAudiorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationAssisAuditorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempInitialValues.nacecode)
                }

                setInitialValues(tempInitialValues)
            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }

    })

    const typeaudit = [
        { key: 'Select', value: '-' },
        { key: 'Certification Audit (Stage 2)', value: 'Certification Audit (Stage 2)' },
        { key: 'Certification Audit (Stage 1)', value: 'Certification Audit (Stage 1)' },
        { key: 'surveillance Audit', value: 'surveillance Audit' },

    ]

    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesauditplandata/'+localStorage.getItem("userCode"), {}))

    // const { data: ProcessList, isLoading: processListLoading } = useQuery(
    //     'listProcessList',
    //     () => Fetcher('get', '/api/process/get/processmasterbykeylabel', {}))
    const mutationgetProcessList = useMutation((params) => Fetcher('get', '/api/process/get/listprocessmastercertwise/'+ params, {}), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                console.log("tempInitialValues 282", data.data.response)
                setProcessList(data.data.response)

            } else {
                var msg = 'ProcessList - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })
    // var temprocess = ProcessList
    if (companyListLoading) return <h1>Loading</h1>
    if (orgcode && initialValues.orgCode === 0){
       
        // window.location.href = "/signin"
          return <h1>Loading Data</h1>
         
       }
    
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                // validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {
                    formik => <Form>
                        <div className="content-wrapper">

                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-sm-12">

                                                        <div className="formOuterDiv">
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='selectNACECode' options={OrgList.data.response} name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} type="text" label='Client Name' />
                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type="text" name='auditrepresentative' label='Auditee’s Representative' />
                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type="text" name='auditobjective' label='Audit Objective' disabled={true} />
                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type="text" name='scope' label='Scope of Application' />
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='standardapplied' label='Standard Applied' />
                                                                <FormikControl control='input' type="text" name='standardapplicable' label='Standard- Not Applicable Requirement' />

                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='select' type="text" name='typeofaudit' options={typeaudit} label='Type of Audit' />
                                                               

                                                            </div>
                                                            <div className="form2RowDiv">
                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" name='dateofaudit' label='Date Of Audit From*' />
                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Date Of Audit To' name='dateofauditto' />
                                                            </div>
                                                            <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="teamleader" label="Team Leader/ Lead Auditor " options={leadauditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`teamleader`,parseInt(e.value))
                                                                    formik.setFieldValue(`teamleaderName`, e.label)
                                                                }}
                                                            />

                                                            <FormikControl control='selectNACECode'  label='Technical Expert'  options={technicalExpertList}   name='technicalexpert'
                                                                     onChange={(e) => {
                                                                            
                                                                        formik.setFieldValue(`technicalexpert`, e.value)
                                                                        formik.setFieldValue(`technicalExpertName`, e.label)
                                                                    }}
                                                                       
                                                                    values={(technicalExpertList).find(i => i.value === `technicalexpert`)} />
                                                           
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="auditorOne" label='Auditor One' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorOne`, parseInt(e.value))
                                                                    formik.setFieldValue(`auditorOneName`, e.label)
                                                                }}
                                                            />

                                                            <FormikControl control="selectNACECode" name="auditorTwo" label='Auditor Two' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorTwo`, e.value)
                                                                    formik.setFieldValue(`auditorTwoName`, e.label)
                                                                }}
                                                            />

                                                        </div>
                                                            {/* <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='teamleaderName' label='Team Leader/Auditor(s)' />
                                                                <FormikControl control='input' type="text" name='technicalExpertName' label='Technical Expert' />

                                                            </div> */}
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type="text" name='accompanyingteam' label='Persons accompanying with Audit Team (if any)' />
                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type="text" name='purpose' label='Purpose' />
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='purposecategories' disabled={true} label='Product Categories & Business Sector:IAF/NABCB-SIC Code' />
                                                                <FormikControl control='input' type="text" name='translator' label='Translator(s)' />

                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='languageofaudit' disabled={true} label='Language of Audit' />
                                                                <FormikControl control='input' type="text" name='referencedocuments' disabled={true} label='Reference Documents' />

                                                            </div>
                                                            <hr />
                                                            <div className="row headingcolor">
                                                            <h6><b>Confidentiality Requirements:</b>Certification activities will be held in strict confidence as defined in the Master Agreement (MA) of IQCPL</h6></div>
                                                            
                                                            <hr />
                                                            <div className="form2RowDiv">
                                                            <FormikControl  control='time' type='text' label='Audit Start Time' onChange={(e)=> formik.setFieldValue(`auditstarttime`,e)} name='auditstarttime' />
                                                            <FormikControl  control='time' type='text' label='Audit End Time' onChange={(e)=> formik.setFieldValue(`auditendtime`,e)} name='auditendtime' />
                                                        </div>


                                                            <div className="form2RowDiv">
                                                             
                                                            <FormikControl  control='time' name='fromtime' onChange={(e)=> formik.setFieldValue(`fromtime`,e)} label='Lunch Start Time' />
                                                            <FormikControl  control='time' name='lunchendtime' onChange={(e)=> formik.setFieldValue(`lunchendtime`,e)} label='Lunch End Time' />

                                                            </div>
                                                            <div className="form1RowDiv" >
                                                                <b><h6>Process Details</h6></b>
                                                            </div>
                                                            <div >

                                                                <div className="fieldarray">
                                                                    <FieldArray name='processDetails'>
                                                                        {fieldArrayProps => {
                                                                            const { push, remove, form } = fieldArrayProps
                                                                            const { values } = form
                                                                            const { processDetails } = values
                                                                            return (
                                                                                <div>
                                                                                    {processDetails.map((processDetail, index) => (
                                                                                        <div key={index}>
                                                                                            <div className="form2RowDiv">
                                                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" name={`processDetails[${index}].dateofaudit`} label='Date Of Audit' />
                                                                                           

                                                                                                <FormikControl control="selectNACECode" name={`processDetails[${index}].processToBeAudited`} label='Process to be Audited *' options={ProcessList}
                                                                                                    onChange={(e) => {
                                                                                                        var tempData = ProcessList
                                                                                                        console.log("tempData",tempData)
                                                                                                        var fillteredprocess = processDetails.find(x => x.processToBeAudited===e.value)
                                                                                                     
                                                                                                        if(fillteredprocess){
                                                                                                            swal({
                                                                                                                title: "Process is Already selected",
                                                                                                                icon: "warning",
                                                                                                                dangerMode: true,
                                                                                                            }) 
                                                                                                        }else{
                                                                                                            var processDetailsResponse = tempData.find(x => x._id === e.value)
                                                                                                            formik.setFieldValue(`processDetails[${index}].processToBeAudited`,processDetailsResponse.value)
                                                                                                            formik.setFieldValue(`processDetails[${index}].processGroup`, processDetailsResponse.processGroup)
                                                                                                            formik.setFieldValue(`processDetails[${index}].auditee`, processDetailsResponse.auditee)
                                                                                                            formik.setFieldValue(`processDetails[${index}].processNametobeAudited`, processDetailsResponse.label)
                                                                                                        }
                                                                                                    }
                                                                                                    
                                                                                                    } 
                                                                                                />
                                                                                               
                                                                                            </div>
                                                                                            <div className="form2RowDiv mt-2">
                                                                                                  <div className="formSingleElement">
                                                                                                    <label className="formSingleElementLabel">Process Selection<span style={{color:"red"}}>*</span></label>
                                                                                                    <Field className="form-control" name={`processDetails[${index}].checkBoxSelection`} as="select">
                                                                                                        <option value="-">Select</option>
                                                                                                        <option value="yes">Yes</option>
                                                                                                        <option value="no">No</option>
                                                                                                    </Field>
                                                                                                    <div style={{color:"red",fontSize:"15px"}}>
                                                                                            <ErrorMessage name={`processDetails[${index}].checkBoxSelection`} />
                                                                                            </div>
                                                                                                </div>

                                                                                                <FormikControl control='input' type="text" name={`processDetails[${index}].processGroup`} label='Process Group' />

                                                                                            </div>




                                                                                            <div className="form2RowDiv mt-2">
                                                                                            <FormikControl control='input' type="text" name={`processDetails[${index}].minutesAssigned`} label='Minutes Assigned*' />

                                                                                                <div className="formSingleElement">
                                                                                                    <label className="formSingleElementLabel">Auditor Compulsion<span style={{color:"red"}}>*</span></label>
                                                                                                    <Field className="form-control" name={`processDetails[${index}].auditorCompulsion`} as="select" >
                                                                                                        <option value="-">Select</option>
                                                                                                        <option value="leadAuditor">Lead Auditor</option>
                                                                                                        <option value="auditor">Auditor</option>
                                                                                                    </Field>  
                                                                                                    <div style={{color:"red",fontSize:"15px"}}>
                                                                                            <ErrorMessage name={`processDetails[${index}].auditorCompulsion`} />
                                                                                            </div>                                                                                    
                                                                                                 </div>
                                                                                                 
                                                                                            </div>


                                                                                            <div className="form2RowDiv mt-3">
                                                                                                <FormikControl control='input' type="text" name={`processDetails[${index}].auditee`} label='Auditee' />

                                                                                                <FormikControl control='time'  name={`processDetails[${index}].proposedValue`}  label="Proposed Time From*"
                                                                                                    onChange={(e)=>{
                                                                                                        var starttime = processDetails[index].minutesAssigned
                                                                                                        var dateofaudit = moment(processDetails[index].dateofaudit).format("DD-MM-YYYY");
                                                                                                        var dateTime = moment(dateofaudit + ' ' + e, 'DD/MM/YYYY HH:mm');
                                                                                                        var expectdTime =  moment(dateTime).add(parseInt(starttime), 'minutes').format('hh:mm A')
                                                                                                        formik.setFieldValue(`processDetails[${index}].proposedValue`,e)
                                                                                                        formik.setFieldValue(`processDetails[${index}].proposedValueTo`,expectdTime)
                                                                                                }
                                                                                            }
                                                                                                />
                                                                                                    </div>
                                                                                                    <div className="form2RowDiv mt-3"> 
                                                                                                        <FormikControl control='time'  name={`processDetails[${index}].proposedValueTo`}  label="Proposed Time To"/>
                                                                                                    </div>                                                                                                {index > 0 && (
                                                                                                    <div className="col-sm-4">
                                                                                                        <span style={{ "marginLeft": "290%", "cursor": "pointer" }} onClick={() => remove(index)}><AiIcons.AiOutlineDelete style={{ widh: "30px", fill: "red" }} /></span>
                                                                                                    </div>
                                                                                                )}
                                                                                           
                                                                                            <hr />
                                                                                        </div>
                                                                                    ))}

                                                                                    <div className="row mt-3">
                                                                                        <div className="col-lg-11"></div>
                                                                                        <div className="col-lg-1 mb-3" >
                                                                                            <button type='button' className="btn btn-primary" onClick={() => push({  dateofaudit:processDetails[0].dateofaudit,
                                                                                            processToBeAudited:"" ,
                                                                                            processNametobeAudited: "",
                                                                                            checkBoxSelection: "",
                                                                                            processGroup: "",
                                                                                            minutesAssigned: "",
                                                                                            auditee: "",
                                                                                            auditorCompulsion: "",
                                                                                            proposedValue: ""})} >Add</button>
                                                                                        </div>
                                                                                    </div>


                                                                                </div>
                                                                            )
                                                                        }}
                                                                    </FieldArray>

                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>
                        <div className="card-footer">
                            <div className="row">
                                <div className="col-lg-10"></div>
                                <div className="col-lg-2">
                                    <button type="submit" className="btn btn-primary" >Submit</button>
                                </div>
                            </div>
                        </div>
                    </Form>
                }
            </Formik>
        </div>
    )
}

export default Stage2AuditPlan
